var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataSchedule(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.17377 10.173C8.89877 10.878 8.22877 11.333 7.47377 11.333H4.52377C3.76377 11.333 3.09877 10.878 2.82377 10.173C2.54877 9.46301 2.73877 8.67801 3.29877 8.16801L5.32377 6.33301H6.67877L8.69877 8.16801C9.25877 8.67801 9.44377 9.46301 9.17377 10.173Z",
    fill: "#92ABFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91 9.23599H5.09C4.99364 9.23599 4.91667 9.15721 4.91667 9.06266C4.91667 8.96629 4.99545 8.88932 5.09 8.88932H6.91C7.00636 8.88932 7.08333 8.9681 7.08333 9.06266C7.08333 9.15561 7.00295 9.23599 6.91 9.23599Z",
    fill: "#92ABFE",
    stroke: "#92ABFE",
    strokeWidth: 0.333333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17533 2.49301C8.90033 1.78801 8.23032 1.33301 7.47532 1.33301H4.52532C3.77032 1.33301 3.10032 1.78801 2.82532 2.49301C2.55532 3.20301 2.74032 3.98801 3.30532 4.49801L5.32532 6.33301H6.68032L8.70032 4.49801C9.26032 3.98801 9.44533 3.20301 9.17533 2.49301ZM6.91032 3.94801H5.09032C4.90032 3.94801 4.75032 3.79301 4.75032 3.60801C4.75032 3.42301 4.90532 3.26801 5.09032 3.26801H6.91032C7.10032 3.26801 7.25032 3.42301 7.25032 3.60801C7.25032 3.79301 7.09532 3.94801 6.91032 3.94801Z",
    fill: "#92ABFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataSchedule);
export default __webpack_public_path__ + "static/media/DataSchedule.979483ab7be43bd13f0dda33b0f6e6fc.svg";
export { ForwardRef as ReactComponent };